/**
 * MUI 아이콘 레지스트리 - 명시적 import로 번들 안정성 확보
 * IconSelector 검색용
 */
import React from 'react';
import {
  // ─── Navigation / Layout ───────────────────────────────────────────────────
  Home,
  HomeWork,
  Menu,
  MenuOpen,
  MenuBook,
  Apps,
  Dashboard,
  GridView,
  ViewList,
  ViewModule,
  ViewComfy,
  ViewSidebar,
  Splitscreen,
  TableChart,
  TableRows,
  List,
  PlaylistAdd,
  PlaylistAddCheck,
  Toc,
  ExpandMore,
  ExpandLess,
  ArrowBack,
  ArrowForward,
  ArrowUpward,
  ArrowDownward,
  ChevronLeft,
  ChevronRight,
  ChevronRightRounded,
  North,
  South,
  East,
  West,
  FirstPage,
  LastPage,
  MoreVert,
  MoreHoriz,
  SubdirectoryArrowRight,
  // ─── Actions / Common ──────────────────────────────────────────────────────
  Add,
  AddCircle,
  AddCircleOutline,
  AddBox,
  Remove,
  RemoveCircle,
  RemoveCircleOutline,
  Edit,
  EditNote,
  EditCalendar,
  Delete,
  DeleteOutline,
  DeleteForever,
  Close,
  CloseFullscreen,
  Check,
  CheckCircle,
  CheckCircleOutline,
  Done,
  DoneAll,
  Save,
  SaveAs,
  Undo,
  Redo,
  Refresh,
  Sync,
  SyncAlt,
  Replay,
  Loop,
  Search,
  SearchOff,
  FilterList,
  FilterListOff,
  FilterAlt,
  Sort,
  SwapVert,
  SwapHoriz,
  OpenInNew,
  OpenInFull,
  Launch,
  Send,
  Forward,
  Reply,
  Share,
  ContentCopy,
  ContentCut,
  ContentPaste,
  SelectAll,
  Deselect,
  Download,
  DownloadForOffline,
  Upload,
  // ─── Files / Folders ───────────────────────────────────────────────────────
  Folder,
  FolderOpen,
  FolderShared,
  FolderSpecial,
  FolderZip,
  CreateNewFolder,
  Description,
  Article,
  Assignment,
  AssignmentTurnedIn,
  AssignmentLate,
  AssignmentReturn,
  AssignmentInd,
  Inventory,
  Inventory2,
  Summarize,
  Receipt,
  ReceiptLong,
  RequestPage,
  FileCopy,
  FileDownload,
  FileUpload,
  FilePresent,
  Attachment,
  Link,
  LinkOff,
  QrCode,
  QrCode2,
  QrCodeScanner,
  // ─── Communication / Contact ───────────────────────────────────────────────
  Email,
  EmailOutlined,
  Phone,
  PhoneEnabled,
  PhoneDisabled,
  PhoneMissed,
  PhoneCallback,
  PhoneForwarded,
  PhonePaused,
  PhoneIphone,
  PhoneAndroid,
  Message,
  MessageOutlined,
  Sms,
  Chat,
  ChatBubble,
  ChatBubbleOutline,
  Forum,
  Comment,
  CommentBank,
  Drafts,
  Inbox,
  Outbox,
  ContactMail,
  ContactPhone,
  Contacts,
  PermContactCalendar,
  // ─── People / Account ──────────────────────────────────────────────────────
  People,
  PeopleAlt,
  PeopleOutline,
  Person,
  PersonAdd,
  PersonAddAlt,
  PersonRemove,
  PersonOff,
  PersonSearch,
  PersonPin,
  Group,
  GroupAdd,
  GroupRemove,
  GroupWork,
  Groups,
  AccountCircle,
  AccountBox,
  ManageAccounts,
  SupervisedUserCircle,
  Engineering,
  // ─── Security / Auth ───────────────────────────────────────────────────────
  Lock,
  LockOpen,
  LockReset,
  AdminPanelSettings,
  Security,
  Shield,
  VpnLock,
  Fingerprint,
  Password,
  Key,
  Policy,
  VerifiedUser,
  Verified,
  Badge,
  // ─── Settings / Config ────────────────────────────────────────────────────
  Settings,
  SettingsApplications,
  SettingsBackupRestore,
  Tune,
  Build,
  BuildCircle,
  HandymanOutlined as Handyman,
  Extension,
  Widgets,
  // ─── Data / Analytics ─────────────────────────────────────────────────────
  BarChart,
  BarChartRounded,
  PieChart,
  PieChartOutline,
  Timeline,
  TrendingUp,
  TrendingDown,
  TrendingFlat,
  Insights,
  Analytics,
  DataUsage,
  DataObject,
  Calculate,
  Numbers,
  Functions,
  // ─── Map / Location ───────────────────────────────────────────────────────
  Map as MapIcon,
  MapOutlined,
  MyLocation,
  LocationOn,
  LocationOff,
  LocationCity,
  Place,
  PinDrop,
  Navigation,
  NearMe,
  Directions,
  DirectionsCar,
  DirectionsWalk,
  DirectionsBike,
  DirectionsBus,
  DirectionsTransit,
  Route,
  Explore,
  Apartment,
  House,
  // ─── Calendar / Time ──────────────────────────────────────────────────────
  CalendarMonth,
  CalendarToday,
  CalendarViewDay,
  CalendarViewWeek,
  CalendarViewMonth,
  EventNote,
  Event,
  EventAvailable,
  EventBusy,
  DateRange,
  Schedule,
  Timer,
  TimerOff,
  Timelapse,
  WatchLater,
  Today,
  AccessTime,
  AccessAlarm,
  Alarm,
  AlarmOn,
  AlarmOff,
  History,
  HistoryEdu,
  HistoryToggleOff,
  Update,
  // ─── Status / Feedback ────────────────────────────────────────────────────
  Notifications,
  NotificationsActive,
  NotificationsOff,
  NotificationsPaused,
  Info,
  InfoOutlined,
  Help,
  HelpOutline,
  HelpCenter,
  Warning,
  WarningAmber,
  ReportProblem,
  Error as ErrorIcon,
  ErrorOutline,
  Cancel,
  Block,
  Flag,
  OutlinedFlag,
  Announcement,
  // ─── Content / Media ──────────────────────────────────────────────────────
  Visibility,
  VisibilityOff,
  Image,
  ImageSearch,
  Photo,
  PhotoLibrary,
  PhotoCamera,
  CameraAlt,
  Videocam,
  VideoFile,
  Audiotrack,
  VolumeUp,
  VolumeOff,
  PlayArrow,
  Pause,
  Stop,
  SkipNext,
  SkipPrevious,
  // ─── Cloud / Storage ──────────────────────────────────────────────────────
  Cloud,
  CloudUpload,
  CloudDownload,
  CloudSync,
  CloudOff,
  CloudDone,
  Backup,
  BackupTable,
  StorageRounded as Storage,
  Dns,
  Computer,
  DevicesOther,
  Laptop,
  Tablet,
  // ─── Commerce / Business ──────────────────────────────────────────────────
  Business,
  BusinessCenter,
  Store,
  StoreMallDirectory,
  ShoppingCart,
  ShoppingBag,
  ShoppingBasket,
  LocalShipping,
  LocalOffer,
  Redeem,
  Payments,
  Payment,
  CreditCard,
  AccountBalance,
  AccountBalanceWallet,
  AttachMoney,
  MonetizationOn,
  PriceCheck,
  // ─── UI Misc ──────────────────────────────────────────────────────────────
  Bookmark,
  BookmarkBorder,
  BookmarkAdd,
  Star,
  StarBorder,
  StarHalf,
  Favorite,
  FavoriteBorder,
  ThumbUp,
  ThumbDown,
  Label,
  LabelOff,
  Tag,
  NewReleases,
  FiberNew,
  Circle,
  RadioButtonUnchecked,
  CheckBox,
  IndeterminateCheckBox,
  ToggleOn,
  ToggleOff,
  Code,
  Terminal,
  BugReport,
  DeveloperMode,
  Api,
  Webhook,
  LightMode,
  DarkMode,
  NightlightRound,
  AutoAwesome,
  Bolt,
  FlashOn,
  Speed,
  Category,
  Grain,
  HorizontalRule,
  // ─── Moving / Service domain ──────────────────────────────────────────────
  MoveToInbox,
  MoveDown,
  MoveUp,
  Handshake,
  SupportAgent,
  HeadsetMic,
  ContactSupport,
  Support,
  FormatListBulleted,
  FormatListNumbered,
  Notes,
  NoteAdd,
  StickyNote2,
  Checklist,
  PlaylistAddCheckCircle,
} from '@mui/icons-material';

/** 아이콘 컴포넌트 타입 */
type IconComponent = React.ComponentType<{ sx?: object }>;

const ICON_REGISTRY: Record<string, IconComponent> = {
  // Navigation / Layout
  Home,
  HomeWork,
  Menu,
  MenuOpen,
  MenuBook,
  Apps,
  Dashboard,
  GridView,
  ViewList,
  ViewModule,
  ViewComfy,
  ViewSidebar,
  Splitscreen,
  TableChart,
  TableRows,
  List,
  PlaylistAdd,
  PlaylistAddCheck,
  Toc,
  ExpandMore,
  ExpandLess,
  ArrowBack,
  ArrowForward,
  ArrowUpward,
  ArrowDownward,
  ChevronLeft,
  ChevronRight,
  ChevronRightRounded,
  North,
  South,
  East,
  West,
  FirstPage,
  LastPage,
  MoreVert,
  MoreHoriz,
  SubdirectoryArrowRight,
  // Actions / Common
  Add,
  AddCircle,
  AddCircleOutline,
  AddBox,
  Remove,
  RemoveCircle,
  RemoveCircleOutline,
  Edit,
  EditNote,
  EditCalendar,
  Delete,
  DeleteOutline,
  DeleteForever,
  Close,
  CloseFullscreen,
  Check,
  CheckCircle,
  CheckCircleOutline,
  Done,
  DoneAll,
  Save,
  SaveAs,
  Undo,
  Redo,
  Refresh,
  Sync,
  SyncAlt,
  Replay,
  Loop,
  Search,
  SearchOff,
  FilterList,
  FilterListOff,
  FilterAlt,
  Sort,
  SwapVert,
  SwapHoriz,
  OpenInNew,
  OpenInFull,
  Launch,
  Send,
  Forward,
  Reply,
  Share,
  ContentCopy,
  ContentCut,
  ContentPaste,
  SelectAll,
  Deselect,
  Download,
  DownloadForOffline,
  Upload,
  // Files / Folders
  Folder,
  FolderOpen,
  FolderShared,
  FolderSpecial,
  FolderZip,
  CreateNewFolder,
  Description,
  Article,
  Assignment,
  AssignmentTurnedIn,
  AssignmentLate,
  AssignmentReturn,
  AssignmentInd,
  Inventory,
  Inventory2,
  Summarize,
  Receipt,
  ReceiptLong,
  RequestPage,
  FileCopy,
  FileDownload,
  FileUpload,
  FilePresent,
  Attachment,
  Link,
  LinkOff,
  QrCode,
  QrCode2,
  QrCodeScanner,
  // Communication / Contact
  Email,
  EmailOutlined,
  Phone,
  PhoneEnabled,
  PhoneDisabled,
  PhoneMissed,
  PhoneCallback,
  PhoneForwarded,
  PhonePaused,
  PhoneIphone,
  PhoneAndroid,
  Message,
  MessageOutlined,
  Sms,
  Chat,
  ChatBubble,
  ChatBubbleOutline,
  Forum,
  Comment,
  CommentBank,
  Drafts,
  Inbox,
  Outbox,
  ContactMail,
  ContactPhone,
  Contacts,
  PermContactCalendar,
  // People / Account
  People,
  PeopleAlt,
  PeopleOutline,
  Person,
  PersonAdd,
  PersonAddAlt,
  PersonRemove,
  PersonOff,
  PersonSearch,
  PersonPin,
  Group,
  GroupAdd,
  GroupRemove,
  GroupWork,
  Groups,
  AccountCircle,
  AccountBox,
  ManageAccounts,
  SupervisedUserCircle,
  Engineering,
  // Security / Auth
  Lock,
  LockOpen,
  LockReset,
  AdminPanelSettings,
  Security,
  Shield,
  VpnLock,
  Fingerprint,
  Password,
  Key,
  Policy,
  VerifiedUser,
  Verified,
  Badge,
  // Settings / Config
  Settings,
  SettingsApplications,
  SettingsBackupRestore,
  Tune,
  Build,
  BuildCircle,
  Handyman,
  Extension,
  Widgets,
  // Data / Analytics

  BarChart,
  BarChartRounded,
  PieChart,
  PieChartOutline,
  Timeline,
  TrendingUp,
  TrendingDown,
  TrendingFlat,
  Insights,
  Analytics,
  DataUsage,
  DataObject,
  Calculate,
  Numbers,
  Functions,
  // Map / Location
  Map: MapIcon,
  MapOutlined,
  MyLocation,
  LocationOn,
  LocationOff,
  LocationCity,
  Place,
  PinDrop,
  Navigation,
  NearMe,
  Directions,
  DirectionsCar,
  DirectionsWalk,
  DirectionsBike,
  DirectionsBus,
  DirectionsTransit,
  Route,
  Explore,
  Apartment,
  House,
  // Calendar / Time
  CalendarMonth,
  CalendarToday,
  CalendarViewDay,
  CalendarViewWeek,
  CalendarViewMonth,
  EventNote,
  Event,
  EventAvailable,
  EventBusy,
  DateRange,
  Schedule,
  Timer,
  TimerOff,
  Timelapse,
  WatchLater,
  Today,
  AccessTime,
  AccessAlarm,
  Alarm,
  AlarmOn,
  AlarmOff,
  History,
  HistoryEdu,
  HistoryToggleOff,
  Update,
  // Status / Feedback
  Notifications,
  NotificationsActive,
  NotificationsOff,
  NotificationsPaused,
  Info,
  InfoOutlined,
  Help,
  HelpOutline,
  HelpCenter,
  Warning,
  WarningAmber,
  ReportProblem,
  Error: ErrorIcon,
  ErrorOutline,
  Cancel,
  Block,
  Flag,
  OutlinedFlag,
  Announcement,
  // Content / Media
  Visibility,
  VisibilityOff,
  Image,
  ImageSearch,
  Photo,
  PhotoLibrary,
  PhotoCamera,
  CameraAlt,
  Videocam,
  VideoFile,
  Audiotrack,
  VolumeUp,
  VolumeOff,
  PlayArrow,
  Pause,
  Stop,
  SkipNext,
  SkipPrevious,
  // Cloud / Storage
  Cloud,
  CloudUpload,
  CloudDownload,
  CloudSync,
  CloudOff,
  CloudDone,
  Backup,
  BackupTable,
  Storage,
  Dns,
  Computer,
  DevicesOther,
  Laptop,
  Tablet,
  // Commerce / Business
  Business,
  BusinessCenter,
  Store,
  StoreMallDirectory,
  ShoppingCart,
  ShoppingBag,
  ShoppingBasket,
  LocalShipping,
  LocalOffer,
  Redeem,
  Payments,
  Payment,
  CreditCard,
  AccountBalance,
  AccountBalanceWallet,
  AttachMoney,
  MonetizationOn,
  PriceCheck,
  // UI Misc
  Bookmark,
  BookmarkBorder,
  BookmarkAdd,
  Star,
  StarBorder,
  StarHalf,
  Favorite,
  FavoriteBorder,
  ThumbUp,
  ThumbDown,
  Label,
  LabelOff,
  Tag,
  NewReleases,
  FiberNew,
  Circle,
  RadioButtonUnchecked,
  CheckBox,
  IndeterminateCheckBox,
  ToggleOn,
  ToggleOff,
  Code,
  Terminal,
  BugReport,
  DeveloperMode,
  Api,
  Webhook,
  LightMode,
  DarkMode,
  NightlightRound,
  AutoAwesome,
  Bolt,
  FlashOn,
  Speed,
  Category,
  Grain,
  HorizontalRule,
  // Moving / Service domain
  MoveToInbox,
  MoveDown,
  MoveUp,
  Handshake,
  SupportAgent,
  HeadsetMic,
  ContactSupport,
  Support,
  FormatListBulleted,
  FormatListNumbered,
  Notes,
  NoteAdd,
  StickyNote2,
  Checklist,
  PlaylistAddCheckCircle,
};

const iconsMap = new Map<string, IconComponent>();
for (const [key, val] of Object.entries(ICON_REGISTRY)) {
  iconsMap.set(key, val);
}

export function getIconComponent(name: string): IconComponent | null {
  return iconsMap.get(name) ?? null;
}

export function getAllIconNames(): string[] {
  return [...iconsMap.keys()].sort();
}

export function searchIcons(query: string): { name: string; component: IconComponent }[] {
  const q = query.trim().toLowerCase();
  const names = getAllIconNames();
  if (!q) return names.map((name) => ({ name, component: iconsMap.get(name)! }));
  return names
    .filter((name) => name.toLowerCase().includes(q))
    .map((name) => ({ name, component: iconsMap.get(name)! }));
}
